import { Injectable } from '@angular/core';

declare var moment;

import {
  PaxFormControlBase,
  PaxFormControlTextbox,
  PaxFormControlRadio,
  PaxFormControlCheckbox,
  PaxFormControlDatepicker
} from './../../shared/index';

@Injectable()
export class FormReviewCoverageService {

  // Signature
  getSignatureDate(): PaxFormControlBase<any> {
    return new PaxFormControlTextbox({
      key: 'signatureDate',
      label: 'Date',
      value: moment().format('MM/DD/YYYY'),
      readonly: true,
      order: 1
    });
  }

  // Signature
  getSignature(): PaxFormControlBase<any> {
    return new PaxFormControlTextbox({
      key: 'signature',
      label: 'Signature',
      placeholder: 'first and last name',
      validation: [{
        name: 'required',
        condition: true,
        message: 'Field is required'
      }],
      order: 1
    });
  }

  // Agree check box 1
  getAgree1(): PaxFormControlBase<any> {
    return new PaxFormControlCheckbox({
      key: 'agreeCheckBox1',
      label: '',
      options: [
        { key: false, value: 'Agree' }
      ],
      validation: [{
        name: 'required',
        condition: true,
        message: 'Please agree'
      }, {
        name: 'requiredTrue',
        condition: true,
        message: 'Please agree'
      }],
      order: 1
    });
  }

  // Agree check box 2
  getAgree2(): PaxFormControlBase<any> {
    return new PaxFormControlCheckbox({
      key: 'agreeCheckBox2',
      label: '',
      options: [
        { key: false, value: 'Agree' }
      ],
      validation: [{
        name: 'required',
        condition: true,
        message: 'Please agree'
      }, {
        name: 'requiredTrue',
        condition: true,
        message: 'Please agree'
      }],
      order: 1
    });
  }

  // Agree check box 3
  getAgree3(): PaxFormControlBase<any> {
    return new PaxFormControlCheckbox({
      key: 'agreeCheckBox3',
      label: '',
      options: [
        { key: false, value: 'Agree' }
      ],
      validation: [{
        name: 'required',
        condition: true,
        message: 'Please agree'
      }, {
        name: 'requiredTrue',
        condition: true,
        message: 'Please agree'
      }],
      order: 1
    });
  }

  getQuestions() {
    let now = moment();
    let datepickerLimit = now.subtract(1, 'day');

    // todo: get data from store?
    let questions: PaxFormControlBase<any>[] = [

      // Would you like to purchase additional $5000 towing coverage in case of an accident
      //  for $20 per unit per month? $5000  is included at no additional charge
      new PaxFormControlRadio({
        key: 'additionalTowingAndStorage',
        label: `Would you like to purchase additional $5000 towing coverage in case of an accident
                for $20 per unit per month? $5000  is included at no additional charge`,
        options: [
          { key: true, value: 'Yes' },
          { key: false, value: 'No' }
        ],
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 1
      }),

      // Requested effective date:
      new PaxFormControlDatepicker({
        key: 'requestedEffectiveDate',
        label: 'Requested effective date:',
        value: '',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 2,
        settings: {
          disableUntil: {
            year: datepickerLimit.get('year'),
            month: datepickerLimit.get('month') + 1, // + 1 because of API's inconsistencies between moment and mydatepicker
            day: datepickerLimit.get('date')
          }
        }
      }),
    ];

    return questions.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/coverage-form/form-review-coverage/form-review-coverage.service.ts